<dx-popup
  [width]="400"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'ACTIVATE-USER.OVERVIEW.TITLE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [(visible)]="showModal"
  class="modal"
  [classList]="'modal'"
>
  <div *dxTemplate="let data of 'content'">
    <p class="description">{{ 'ACTIVATE-USER.OVERVIEW.TEXT' | translate }}</p>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="cancelButtonOptions"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="activateButtonOptions"
  ></dxi-popup-toolbar-item>
</dx-popup>